import { useRef, useState } from 'react'
import { useNavigate } from 'react-router'

import { LoginForm } from '@paysense-india-services/auth-vista'

import { AUTH_FORM_VARIANT } from '@/constants/layout'
import { ROUTES } from '@/constants/routes'

import { useProductConfig } from '@/contexts/ProductConfigContext'

import { parseErrorMessage } from '@/utils/errorParser'

import AuthFormShell from '@/components/layouts/AuthFormShell'

import {
  getProductRequest,
  normalizeProductResponse,
  PRODUCT_OPERATIONS
} from '@/config/productApi'
import { DEFAULT_LOGIN_BRANDING } from '@/config/products'
import { setStoredMobile, setStoredOtpId, setStoredPendingPhoneOtp } from '@/config/sourceStorage'

const LoginPage = () => {
  const [data, setData] = useState({})
  const [error, setError] = useState({})
  const lastSubmittedMobileRef = useRef(null)
  const navigate = useNavigate()
  const { config, appendProductParams } = useProductConfig()

  const sendOtpUrl = getProductRequest(config, PRODUCT_OPERATIONS.SEND_OTP, {}).url

  const mapRequestBody = mobile => {
    lastSubmittedMobileRef.current = mobile
    const { data: reqData, headers } = getProductRequest(config, PRODUCT_OPERATIONS.SEND_OTP, {
      phone: mobile
    })
    return { data: reqData, headers }
  }

  const handleGetOTPSuccess = res => {
    const mobile = lastSubmittedMobileRef.current
    if (mobile) {
      setStoredMobile(mobile)
      setStoredPendingPhoneOtp(mobile)
    }

    const result = normalizeProductResponse(config, PRODUCT_OPERATIONS.SEND_OTP, res)
    if (result.otpId) setStoredOtpId(result.otpId)
    setData({ ...res })
    const query = appendProductParams()
    navigate(`${ROUTES.PHONE_OTP}?${query.toString()}`)
  }

  const handleGetOTPError = err => {
    setStoredMobile(null)
    setStoredPendingPhoneOtp(null)
    setStoredOtpId(null)
    lastSubmittedMobileRef.current = null
    setError({ message: parseErrorMessage(err) || 'Something went wrong' })
  }

  return (
    <AuthFormShell headerVariant="logo" hideHeaderOnDesktop variant={AUTH_FORM_VARIANT.FLUID}>
      <LoginForm
        api={sendOtpUrl}
        config={{
          title: config.branding?.loginTitle ?? DEFAULT_LOGIN_BRANDING.loginTitle,
          subTitle: config.branding?.loginSubtitle ?? DEFAULT_LOGIN_BRANDING.loginSubtitle
        }}
        data={data}
        error={error}
        getRequestBody={mapRequestBody}
        isDisabled={error?.message}
        onChange={() => setError({})}
        onError={handleGetOTPError}
        onSuccess={handleGetOTPSuccess}
      />
    </AuthFormShell>
  )
}

export default LoginPage
